import { statusAuditTrail } from '@/store/params';
import { date } from '../../../../lib/helpers';
import { headers, search } from './attributes';

export default {
  data: () => ({
    options: {},
    headers,
    search,
    expandedFields: [
      { label: 'Request Header', key: 'request_header' },
      { label: 'Request Body', key: 'request_raw' },
      { label: 'Response Header', key: 'response_header' },
      { label: 'Response Body', key: 'response_raw' },
      { label: 'Reference', key: 'reference' },
      { label: 'Error Description', key: 'error_description' },
      { label: 'Merchant ID', key: 'merchant_id' },
    ],
    filterValue: {
      process_name: '',
      trace_id: '',
      merchant_id: '',
      status: '',
      request_date: [],
    },
    filterType: [
      { key: 'trace_id', type: 'textfield', props: { label: 'Trace ID' } },
      { key: 'process_name', type: 'textfield', props: { label: 'Type' } },
      { key: 'merchant_id', type: 'textfield', props: { label: 'Merchant ID' } },
      { key: 'status', type: 'select', props: { label: 'Status', items: statusAuditTrail } },
      { key: 'request_date', type: 'daterange', props: { label: 'Request Date & Time', includeToday: true, limitRangeTo30Days: true, defaultToday: true, withTime: true } },
    ],
  }),

  computed: {
    allData() {
      return this.$store.state.bankAsServer.allData;
    },
    totalData() {
      return this.$store.state.bankAsServer.totalData;
    },
    totalPage() {
      return this.$store.state.bankAsServer.totalPage;
    },
    loading() {
      return this.$store.state.bankAsServer.loading;
    },
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
    },
  },
  methods: {

    baseFilterData(newSearch) {
      this.search.trace_id = newSearch.trace_id || '';
      this.search.process_name = newSearch.process_name || '';
      this.search.merchant_id = newSearch.merchant_id || '';
      this.search.status = newSearch.status || '';
      this.search.request_date = newSearch.request_date || [];
      this.options.page = 1;
      this.getData();
    },
    updateSearch(newSearch) {
      this.baseFilterData(newSearch);
    },
    showType(newSearch) {
      this.baseFilterData(newSearch);
    },
    getData() {
      const { page, itemsPerPage } = this.options;

      this.$store
        .dispatch('bankAsServer/getData', {
          date,
          page,
          itemsPerPage,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            this.options.page = this.totalPage === 0 ? 1 : this.totalPage;
          }
        });
    },
    copyToClipboard(content) {
      const text = typeof content === 'object' ? JSON.stringify(content, null, 2) : content;
      navigator.clipboard.writeText(text);
    },
    clearSearch() {
      this.search.request_date = [];
      this.search.trace_id = '';
      this.search.process_name = '';
      this.search.merchant_id = '';
      this.search.status = '';
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};
